export default {
  isFeedMode: false,
  page: 0,
  totalCount: null,
  isLoading: false,
  query: '',
  items: [],
}
